webpackJsonp([13],{

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("j1ja");
module.exports = __webpack_require__("NHnr");


/***/ }),

/***/ "3swW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('rwv-header'),_vm._v(" "),_c('router-view'),_vm._v(" "),_c('rwv-footer')],1)}
var staticRenderFns = []


/***/ }),

/***/ "5MmI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var ID_TOKEN_KEY = 'id_token';

/* harmony default export */ __webpack_exports__["a"] = ({
  getToken: function getToken() {
    return window.localStorage.getItem(ID_TOKEN_KEY);
  },
  saveToken: function saveToken(token) {
    window.localStorage.setItem(ID_TOKEN_KEY, token);
  },
  destroyToken: function destroyToken() {
    window.localStorage.removeItem(ID_TOKEN_KEY);
  }
});

/***/ }),

/***/ "9J7/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__("NYxO");
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'RwvHeader',
  computed: _extends({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuex__["a" /* mapGetters */])(['currentUser', 'isAuthenticated']))
});

/***/ }),

/***/ "AezD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return FETCH_END; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return FETCH_START; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return PURGE_AUTH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return SET_ARTICLE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return SET_AUTH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return SET_COMMENTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return SET_ERROR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SET_PROFILE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return SET_TAGS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return TAG_ADD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return TAG_REMOVE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return UPDATE_ARTICLE_IN_LIST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return RESET_STATE; });
var FETCH_END = 'setArticles';
var FETCH_START = 'setLoading';
var PURGE_AUTH = 'logOut';
var SET_ARTICLE = 'setArticle';
var SET_AUTH = 'setUser';
var SET_COMMENTS = 'setComments';
var SET_ERROR = 'setError';
var SET_PROFILE = 'setProfile';
var SET_TAGS = 'setTags';
var TAG_ADD = 'addTag';
var TAG_REMOVE = 'removeTag';
var UPDATE_ARTICLE_IN_LIST = 'updateAricleInList';
var RESET_STATE = 'resetModuleState';

/***/ }),

/***/ "BVEk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TheHeader_vue__ = __webpack_require__("9J7/");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_55c8f527_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TheHeader_vue__ = __webpack_require__("tkzz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TheHeader_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_55c8f527_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TheHeader_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_55c8f527_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TheHeader_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "D39R":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export state */
/* unused harmony export actions */
/* unused harmony export mutations */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_api_service__ = __webpack_require__("LguZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions_type__ = __webpack_require__("lHQJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mutations_type__ = __webpack_require__("AezD");
var _actions, _mutations;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }






var initialState = {
  article: {
    author: {},
    title: '',
    description: '',
    body: '',
    tagList: []
  },
  comments: []
};

var state = Object.assign({}, initialState);

var actions = (_actions = {}, _defineProperty(_actions, __WEBPACK_IMPORTED_MODULE_2__actions_type__["e" /* FETCH_ARTICLE */], function (context, articleSlug, prevArticle) {
  // avoid extronuous network call if article exists
  if (prevArticle !== undefined) {
    return context.commit(__WEBPACK_IMPORTED_MODULE_3__mutations_type__["b" /* SET_ARTICLE */], prevArticle);
  }
  return __WEBPACK_IMPORTED_MODULE_1__common_api_service__["b" /* ArticlesService */].get(articleSlug).then(function (_ref) {
    var data = _ref.data;

    context.commit(__WEBPACK_IMPORTED_MODULE_3__mutations_type__["b" /* SET_ARTICLE */], data.article);
    return data;
  });
}), _defineProperty(_actions, __WEBPACK_IMPORTED_MODULE_2__actions_type__["f" /* FETCH_COMMENTS */], function (context, articleSlug) {
  return __WEBPACK_IMPORTED_MODULE_1__common_api_service__["c" /* CommentsService */].get(articleSlug).then(function (_ref2) {
    var data = _ref2.data;

    context.commit(__WEBPACK_IMPORTED_MODULE_3__mutations_type__["c" /* SET_COMMENTS */], data.comments);
  });
}), _defineProperty(_actions, __WEBPACK_IMPORTED_MODULE_2__actions_type__["g" /* COMMENT_CREATE */], function (context, payload) {
  return __WEBPACK_IMPORTED_MODULE_1__common_api_service__["c" /* CommentsService */].post(payload.slug, payload.comment).then(function () {
    context.dispatch(__WEBPACK_IMPORTED_MODULE_2__actions_type__["f" /* FETCH_COMMENTS */], payload.slug);
  });
}), _defineProperty(_actions, __WEBPACK_IMPORTED_MODULE_2__actions_type__["h" /* COMMENT_DESTROY */], function (context, payload) {
  return __WEBPACK_IMPORTED_MODULE_1__common_api_service__["c" /* CommentsService */].destroy(payload.slug, payload.commentId).then(function () {
    context.dispatch(__WEBPACK_IMPORTED_MODULE_2__actions_type__["f" /* FETCH_COMMENTS */], payload.slug);
  });
}), _defineProperty(_actions, __WEBPACK_IMPORTED_MODULE_2__actions_type__["i" /* FAVORITE_ADD */], function (context, payload) {
  return __WEBPACK_IMPORTED_MODULE_1__common_api_service__["d" /* FavoriteService */].add(payload).then(function (_ref3) {
    var data = _ref3.data;

    // Update list as well. This allows us to favorite an article in the Home view.
    context.commit(__WEBPACK_IMPORTED_MODULE_3__mutations_type__["d" /* UPDATE_ARTICLE_IN_LIST */], data.article, { root: true });
    context.commit(__WEBPACK_IMPORTED_MODULE_3__mutations_type__["b" /* SET_ARTICLE */], data.article);
  });
}), _defineProperty(_actions, __WEBPACK_IMPORTED_MODULE_2__actions_type__["j" /* FAVORITE_REMOVE */], function (context, payload) {
  return __WEBPACK_IMPORTED_MODULE_1__common_api_service__["d" /* FavoriteService */].remove(payload).then(function (_ref4) {
    var data = _ref4.data;

    // Update list as well. This allows us to favorite an article in the Home view.
    context.commit(__WEBPACK_IMPORTED_MODULE_3__mutations_type__["d" /* UPDATE_ARTICLE_IN_LIST */], data.article, { root: true });
    context.commit(__WEBPACK_IMPORTED_MODULE_3__mutations_type__["b" /* SET_ARTICLE */], data.article);
  });
}), _defineProperty(_actions, __WEBPACK_IMPORTED_MODULE_2__actions_type__["k" /* ARTICLE_PUBLISH */], function (_ref5) {
  var state = _ref5.state;

  return __WEBPACK_IMPORTED_MODULE_1__common_api_service__["b" /* ArticlesService */].create(state.article);
}), _defineProperty(_actions, __WEBPACK_IMPORTED_MODULE_2__actions_type__["l" /* ARTICLE_DELETE */], function (context, slug) {
  return __WEBPACK_IMPORTED_MODULE_1__common_api_service__["b" /* ArticlesService */].destroy(slug);
}), _defineProperty(_actions, __WEBPACK_IMPORTED_MODULE_2__actions_type__["m" /* ARTICLE_EDIT */], function (_ref6) {
  var state = _ref6.state;

  return __WEBPACK_IMPORTED_MODULE_1__common_api_service__["b" /* ArticlesService */].update(state.article.slug, state.article);
}), _defineProperty(_actions, __WEBPACK_IMPORTED_MODULE_2__actions_type__["n" /* ARTICLE_EDIT_ADD_TAG */], function (context, tag) {
  context.commit(__WEBPACK_IMPORTED_MODULE_3__mutations_type__["e" /* TAG_ADD */], tag);
}), _defineProperty(_actions, __WEBPACK_IMPORTED_MODULE_2__actions_type__["o" /* ARTICLE_EDIT_REMOVE_TAG */], function (context, tag) {
  context.commit(__WEBPACK_IMPORTED_MODULE_3__mutations_type__["f" /* TAG_REMOVE */], tag);
}), _defineProperty(_actions, __WEBPACK_IMPORTED_MODULE_2__actions_type__["p" /* ARTICLE_RESET_STATE */], function (_ref7) {
  var commit = _ref7.commit;

  commit(__WEBPACK_IMPORTED_MODULE_3__mutations_type__["g" /* RESET_STATE */]);
}), _actions);

/* eslint no-param-reassign: ["error", { "props": false }] */
var mutations = (_mutations = {}, _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__mutations_type__["b" /* SET_ARTICLE */], function (state, article) {
  state.article = article;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__mutations_type__["c" /* SET_COMMENTS */], function (state, comments) {
  state.comments = comments;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__mutations_type__["e" /* TAG_ADD */], function (state, tag) {
  state.article.tagList = state.article.tagList.concat([tag]);
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__mutations_type__["f" /* TAG_REMOVE */], function (state, tag) {
  state.article.tagList = state.article.tagList.filter(function (t) {
    return t !== tag;
  });
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__mutations_type__["g" /* RESET_STATE */], function () {
  for (var f in state) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].set(state, f, initialState[f]);
  }
}), _mutations);

var getters = {
  article: function article(state) {
    return state.article;
  },
  comments: function comments(state) {
    return state.comments;
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  actions: actions,
  mutations: mutations,
  getters: getters
});

/***/ }),

/***/ "GTdA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_date_fns_format__ = __webpack_require__("Eoz/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_date_fns_format___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_date_fns_format__);


/* harmony default export */ __webpack_exports__["a"] = (function (date) {
  return __WEBPACK_IMPORTED_MODULE_0_date_fns_format___default()(new Date(date), 'MMMM D, YYYY');
});

/***/ }),

/***/ "GyQG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TheFooter_vue__ = __webpack_require__("UVMV");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4961cbf6_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TheFooter_vue__ = __webpack_require__("T3GY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TheFooter_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4961cbf6_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TheFooter_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4961cbf6_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TheFooter_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "IcnI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__home_module__ = __webpack_require__("Kits");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__auth_module__ = __webpack_require__("itPX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__article_module__ = __webpack_require__("D39R");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__profile_module__ = __webpack_require__("IyCy");








__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* default */].Store({
  modules: {
    home: __WEBPACK_IMPORTED_MODULE_2__home_module__["a" /* default */],
    auth: __WEBPACK_IMPORTED_MODULE_3__auth_module__["a" /* default */],
    article: __WEBPACK_IMPORTED_MODULE_4__article_module__["a" /* default */],
    profile: __WEBPACK_IMPORTED_MODULE_5__profile_module__["a" /* default */]
  }
}));

/***/ }),

/***/ "IyCy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_api_service__ = __webpack_require__("LguZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__actions_type__ = __webpack_require__("lHQJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mutations_type__ = __webpack_require__("AezD");
var _actions;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }





var state = {
  errors: {},
  profile: {}
};

var getters = {
  profile: function profile(state) {
    return state.profile;
  }
};

var actions = (_actions = {}, _defineProperty(_actions, __WEBPACK_IMPORTED_MODULE_1__actions_type__["b" /* FETCH_PROFILE */], function (context, payload) {
  var username = payload.username;

  return __WEBPACK_IMPORTED_MODULE_0__common_api_service__["a" /* default */].get('profiles', username).then(function (_ref) {
    var data = _ref.data;

    context.commit(__WEBPACK_IMPORTED_MODULE_2__mutations_type__["a" /* SET_PROFILE */], data.profile);
    return data;
  }).catch(function (_ref2) {
    // #todo SET_ERROR cannot work in multiple states
    // context.commit(SET_ERROR, response.data.errors)

    var response = _ref2.response;
  });
}), _defineProperty(_actions, __WEBPACK_IMPORTED_MODULE_1__actions_type__["c" /* FETCH_PROFILE_FOLLOW */], function (context, payload) {
  var username = payload.username;

  return __WEBPACK_IMPORTED_MODULE_0__common_api_service__["a" /* default */].post('profiles/' + username + '/follow').then(function (_ref3) {
    var data = _ref3.data;

    context.commit(__WEBPACK_IMPORTED_MODULE_2__mutations_type__["a" /* SET_PROFILE */], data.profile);
    return data;
  }).catch(function (_ref4) {
    // #todo SET_ERROR cannot work in multiple states
    // context.commit(SET_ERROR, response.data.errors)

    var response = _ref4.response;
  });
}), _defineProperty(_actions, __WEBPACK_IMPORTED_MODULE_1__actions_type__["d" /* FETCH_PROFILE_UNFOLLOW */], function (context, payload) {
  var username = payload.username;

  return __WEBPACK_IMPORTED_MODULE_0__common_api_service__["a" /* default */].delete('profiles/' + username + '/follow').then(function (_ref5) {
    var data = _ref5.data;

    context.commit(__WEBPACK_IMPORTED_MODULE_2__mutations_type__["a" /* SET_PROFILE */], data.profile);
    return data;
  }).catch(function (_ref6) {
    // #todo SET_ERROR cannot work in multiple states
    // context.commit(SET_ERROR, response.data.errors)

    var response = _ref6.response;
  });
}), _actions);

var mutations = _defineProperty({}, __WEBPACK_IMPORTED_MODULE_2__mutations_type__["a" /* SET_PROFILE */], function (state, profile) {
  state.profile = profile;
  state.errors = {};
});

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  actions: actions,
  mutations: mutations,
  getters: getters
});

/***/ }),

/***/ "Kits":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_api_service__ = __webpack_require__("LguZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__actions_type__ = __webpack_require__("lHQJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mutations_type__ = __webpack_require__("AezD");
var _actions, _mutations;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }





var state = {
  tags: [],
  articles: [],
  isLoading: true,
  articlesCount: 0
};

var getters = {
  articlesCount: function articlesCount(state) {
    return state.articlesCount;
  },
  articles: function articles(state) {
    return state.articles;
  },
  isLoading: function isLoading(state) {
    return state.isLoading;
  },
  tags: function tags(state) {
    return state.tags;
  }
};

var actions = (_actions = {}, _defineProperty(_actions, __WEBPACK_IMPORTED_MODULE_1__actions_type__["u" /* FETCH_ARTICLES */], function (_ref, params) {
  var commit = _ref.commit;

  commit(__WEBPACK_IMPORTED_MODULE_2__mutations_type__["k" /* FETCH_START */]);
  return __WEBPACK_IMPORTED_MODULE_0__common_api_service__["b" /* ArticlesService */].query(params.type, params.filters).then(function (_ref2) {
    var data = _ref2.data;

    commit(__WEBPACK_IMPORTED_MODULE_2__mutations_type__["l" /* FETCH_END */], data);
  }).catch(function (error) {
    throw new Error(error);
  });
}), _defineProperty(_actions, __WEBPACK_IMPORTED_MODULE_1__actions_type__["v" /* FETCH_TAGS */], function (_ref3) {
  var commit = _ref3.commit;

  return __WEBPACK_IMPORTED_MODULE_0__common_api_service__["e" /* TagsService */].get().then(function (_ref4) {
    var data = _ref4.data;

    commit(__WEBPACK_IMPORTED_MODULE_2__mutations_type__["m" /* SET_TAGS */], data.tags);
  }).catch(function (error) {
    throw new Error(error);
  });
}), _actions);

/* eslint no-param-reassign: ["error", { "props": false }] */
var mutations = (_mutations = {}, _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_2__mutations_type__["k" /* FETCH_START */], function (state) {
  state.isLoading = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_2__mutations_type__["l" /* FETCH_END */], function (state, _ref5) {
  var articles = _ref5.articles,
      articlesCount = _ref5.articlesCount;

  state.articles = articles;
  state.articlesCount = articlesCount;
  state.isLoading = false;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_2__mutations_type__["m" /* SET_TAGS */], function (state, tags) {
  state.tags = tags;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_2__mutations_type__["d" /* UPDATE_ARTICLE_IN_LIST */], function (state, data) {
  state.articles = state.articles.map(function (article) {
    if (article.slug !== data.slug) {
      return article;
    }
    // We could just return data, but it seems dangerous to
    // mix the results of different api calls, so we
    // protect ourselves by copying the information.
    article.favorited = data.favorited;
    article.favoritesCount = data.favoritesCount;
    return article;
  });
}), _mutations);

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
});

/***/ }),

/***/ "LguZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return TagsService; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ArticlesService; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return CommentsService; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return FavoriteService; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_axios__ = __webpack_require__("Rf8U");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_jwt_service__ = __webpack_require__("5MmI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_config__ = __webpack_require__("wYMm");






var ApiService = {
  init: function init() {
    __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_2_vue_axios___default.a, __WEBPACK_IMPORTED_MODULE_1_axios___default.a);
    __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].axios.defaults.baseURL = __WEBPACK_IMPORTED_MODULE_4__common_config__["a" /* API_URL */];
  },
  setHeader: function setHeader() {
    __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].axios.defaults.headers.common['Authorization'] = 'Token ' + __WEBPACK_IMPORTED_MODULE_3__common_jwt_service__["a" /* default */].getToken();
  },
  query: function query(resource, params) {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].axios.get(resource, params).catch(function (error) {
      throw new Error('[RWV] ApiService ' + error);
    });
  },
  get: function get(resource) {
    var slug = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

    return slug ? __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].axios.get(resource + '/' + slug).catch(function (error) {
      throw new Error('[RWV] ApiService ' + error);
    }) : __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].axios.get('' + resource).catch(function (error) {
      throw new Error('[RWV] ApiService ' + error);
    });
  },
  post: function post(resource, params) {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].axios.post('' + resource, params);
  },
  update: function update(resource, slug, params) {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].axios.put(resource + '/' + slug, params);
  },
  put: function put(resource, params) {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].axios.put('' + resource, params);
  },
  delete: function _delete(resource) {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].axios.delete(resource).catch(function (error) {
      throw new Error('[RWV] ApiService ' + error);
    });
  }
};

/* harmony default export */ __webpack_exports__["a"] = (ApiService);

var TagsService = {
  get: function get() {
    return ApiService.get('tags');
  }
};

var ArticlesService = {
  query: function query(type, params) {
    return ApiService.query('articles' + (type === 'feed' ? '/feed' : ''), { params: params });
  },
  get: function get(slug) {
    return ApiService.get('articles', slug);
  },
  create: function create(params) {
    return ApiService.post('articles', { article: params });
  },
  update: function update(slug, params) {
    return ApiService.update('articles', slug, { article: params });
  },
  destroy: function destroy(slug) {
    return ApiService.delete('articles/' + slug);
  }
};

var CommentsService = {
  get: function get(slug) {
    if (typeof slug !== 'string') {
      throw new Error('[RWV] CommentsService.get() article slug required to fetch comments');
    }
    return ApiService.get('articles', slug + '/comments');
  },
  post: function post(slug, payload) {
    return ApiService.post('articles/' + slug + '/comments', { comment: { body: payload } });
  },
  destroy: function destroy(slug, commentId) {
    return ApiService.delete('articles/' + slug + '/comments/' + commentId);
  }
};

var FavoriteService = {
  add: function add(slug) {
    return ApiService.post('articles/' + slug + '/favorite');
  },
  remove: function remove(slug) {
    return ApiService.delete('articles/' + slug + '/favorite');
  }
};

/***/ }),

/***/ "M93x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__("xJD8");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4a16420e_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__("3swW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
function injectStyle (context) {
  __webpack_require__("RB0i")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4a16420e_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4a16420e_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__("M93x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__("YaEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store__ = __webpack_require__("IcnI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store_actions_type__ = __webpack_require__("lHQJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_api_service__ = __webpack_require__("LguZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__common_date_filter__ = __webpack_require__("GTdA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__common_error_filter__ = __webpack_require__("hgdF");
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.











__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].filter('date', __WEBPACK_IMPORTED_MODULE_6__common_date_filter__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].filter('error', __WEBPACK_IMPORTED_MODULE_7__common_error_filter__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_5__common_api_service__["a" /* default */].init();

// Ensure we checked auth before each page load.
__WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].beforeEach(function (to, from, next) {
  return Promise.all([__WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].dispatch(__WEBPACK_IMPORTED_MODULE_4__store_actions_type__["a" /* CHECK_AUTH */])]).then(next);
});

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  store: __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_1__App__["a" /* default */] }
});

/***/ }),

/***/ "RB0i":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "T3GY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',[_c('div',{staticClass:"container"},[_c('router-link',{staticClass:"logo-font",attrs:{"to":{ name: 'home', params: {} }}},[_vm._v("\n      conduit\n    ")]),_vm._v(" "),_vm._m(0)],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"attribution"},[_vm._v("\n      An interactive learning project from\n      "),_c('a',{attrs:{"target":"blank","href":"https://thinkster.io"}},[_vm._v("Thinkster")]),_vm._v(". Code & design licensed under MIT.\n    ")])}]


/***/ }),

/***/ "UVMV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'rwvFooter'
});

/***/ }),

/***/ "YaEn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__("/ocq");



__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: [{
    path: '/',
    component: function component() {
      return __webpack_require__.e/* import() */(6).then(__webpack_require__.bind(null, "j7e0"));
    },
    children: [{
      path: '',
      name: 'home',
      component: function component() {
        return __webpack_require__.e/* import() */(5).then(__webpack_require__.bind(null, "Ff+O"));
      }
    }, {
      path: 'my-feed',
      name: 'home-my-feed',
      component: function component() {
        return __webpack_require__.e/* import() */(4).then(__webpack_require__.bind(null, "2Om/"));
      }
    }, {
      path: 'tag/:tag',
      name: 'home-tag',
      component: function component() {
        return __webpack_require__.e/* import() */(3).then(__webpack_require__.bind(null, "kzGc"));
      }
    }]
  }, {
    name: 'login',
    path: '/login',
    component: function component() {
      return __webpack_require__.e/* import() */(11).then(__webpack_require__.bind(null, "lmfZ"));
    }
  }, {
    name: 'register',
    path: '/register',
    component: function component() {
      return __webpack_require__.e/* import() */(9).then(__webpack_require__.bind(null, "tcoL"));
    }
  }, {
    name: 'settings',
    path: '/settings',
    component: function component() {
      return __webpack_require__.e/* import() */(8).then(__webpack_require__.bind(null, "VKKr"));
    }
  },
  // Handle child routes with a default, by giving the name to the
  // child.
  // SO: https://github.com/vuejs/vue-router/issues/777
  {
    path: '/@:username',
    component: function component() {
      return __webpack_require__.e/* import() */(10).then(__webpack_require__.bind(null, "Twgf"));
    },
    children: [{
      path: '',
      name: 'profile',
      component: function component() {
        return __webpack_require__.e/* import() */(2).then(__webpack_require__.bind(null, "bzRz"));
      }
    }, {
      name: 'profile-favorites',
      path: 'favorites',
      component: function component() {
        return __webpack_require__.e/* import() */(1).then(__webpack_require__.bind(null, "2XD+"));
      }
    }]
  }, {
    name: 'article',
    path: '/articles/:slug',
    component: function component() {
      return __webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, "UbIS"));
    },
    props: true
  }, {
    name: 'article-edit',
    path: '/editor/:slug?',
    props: true,
    component: function component() {
      return __webpack_require__.e/* import() */(7).then(__webpack_require__.bind(null, "tFGQ"));
    }
  }]
}));

/***/ }),

/***/ "hgdF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

/* harmony default export */ __webpack_exports__["a"] = (function (errorValue) {
  return "" + errorValue[0];
});

/***/ }),

/***/ "itPX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_api_service__ = __webpack_require__("LguZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_jwt_service__ = __webpack_require__("5MmI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions_type__ = __webpack_require__("lHQJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mutations_type__ = __webpack_require__("AezD");
var _actions, _mutations;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }






var state = {
  errors: null,
  user: {},
  isAuthenticated: !!__WEBPACK_IMPORTED_MODULE_1__common_jwt_service__["a" /* default */].getToken()
};

var getters = {
  currentUser: function currentUser(state) {
    return state.user;
  },
  isAuthenticated: function isAuthenticated(state) {
    return state.isAuthenticated;
  }
};

var actions = (_actions = {}, _defineProperty(_actions, __WEBPACK_IMPORTED_MODULE_2__actions_type__["q" /* LOGIN */], function (context, credentials) {
  return new Promise(function (resolve) {
    __WEBPACK_IMPORTED_MODULE_0__common_api_service__["a" /* default */].post('users/login', { user: credentials }).then(function (_ref) {
      var data = _ref.data;

      context.commit(__WEBPACK_IMPORTED_MODULE_3__mutations_type__["h" /* SET_AUTH */], data.user);
      resolve(data);
    }).catch(function (_ref2) {
      var response = _ref2.response;

      context.commit(__WEBPACK_IMPORTED_MODULE_3__mutations_type__["i" /* SET_ERROR */], response.data.errors);
    });
  });
}), _defineProperty(_actions, __WEBPACK_IMPORTED_MODULE_2__actions_type__["r" /* LOGOUT */], function (context) {
  context.commit(__WEBPACK_IMPORTED_MODULE_3__mutations_type__["j" /* PURGE_AUTH */]);
}), _defineProperty(_actions, __WEBPACK_IMPORTED_MODULE_2__actions_type__["s" /* REGISTER */], function (context, credentials) {
  return new Promise(function (resolve, reject) {
    __WEBPACK_IMPORTED_MODULE_0__common_api_service__["a" /* default */].post('users', { user: credentials }).then(function (_ref3) {
      var data = _ref3.data;

      context.commit(__WEBPACK_IMPORTED_MODULE_3__mutations_type__["h" /* SET_AUTH */], data.user);
      resolve(data);
    }).catch(function (_ref4) {
      var response = _ref4.response;

      context.commit(__WEBPACK_IMPORTED_MODULE_3__mutations_type__["i" /* SET_ERROR */], response.data.errors);
    });
  });
}), _defineProperty(_actions, __WEBPACK_IMPORTED_MODULE_2__actions_type__["a" /* CHECK_AUTH */], function (context) {
  if (__WEBPACK_IMPORTED_MODULE_1__common_jwt_service__["a" /* default */].getToken()) {
    __WEBPACK_IMPORTED_MODULE_0__common_api_service__["a" /* default */].setHeader();
    __WEBPACK_IMPORTED_MODULE_0__common_api_service__["a" /* default */].get('user').then(function (_ref5) {
      var data = _ref5.data;

      context.commit(__WEBPACK_IMPORTED_MODULE_3__mutations_type__["h" /* SET_AUTH */], data.user);
    }).catch(function (_ref6) {
      var response = _ref6.response;

      context.commit(__WEBPACK_IMPORTED_MODULE_3__mutations_type__["i" /* SET_ERROR */], response.data.errors);
    });
  } else {
    context.commit(__WEBPACK_IMPORTED_MODULE_3__mutations_type__["j" /* PURGE_AUTH */]);
  }
}), _defineProperty(_actions, __WEBPACK_IMPORTED_MODULE_2__actions_type__["t" /* UPDATE_USER */], function (context, payload) {
  var email = payload.email,
      username = payload.username,
      password = payload.password,
      image = payload.image,
      bio = payload.bio;

  var user = {
    email: email,
    username: username,
    bio: bio,
    image: image
  };
  if (password) {
    user.password = password;
  }

  return __WEBPACK_IMPORTED_MODULE_0__common_api_service__["a" /* default */].put('user', user).then(function (_ref7) {
    var data = _ref7.data;

    context.commit(__WEBPACK_IMPORTED_MODULE_3__mutations_type__["h" /* SET_AUTH */], data.user);
    return data;
  });
}), _actions);

var mutations = (_mutations = {}, _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__mutations_type__["i" /* SET_ERROR */], function (state, error) {
  state.errors = error;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__mutations_type__["h" /* SET_AUTH */], function (state, user) {
  state.isAuthenticated = true;
  state.user = user;
  state.errors = {};
  __WEBPACK_IMPORTED_MODULE_1__common_jwt_service__["a" /* default */].saveToken(state.user.token);
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__mutations_type__["j" /* PURGE_AUTH */], function (state) {
  state.isAuthenticated = false;
  state.user = {};
  state.errors = {};
  __WEBPACK_IMPORTED_MODULE_1__common_jwt_service__["a" /* default */].destroyToken();
}), _mutations);

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  actions: actions,
  mutations: mutations,
  getters: getters
});

/***/ }),

/***/ "lHQJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return ARTICLE_PUBLISH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return ARTICLE_DELETE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return ARTICLE_EDIT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return ARTICLE_EDIT_ADD_TAG; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return ARTICLE_EDIT_REMOVE_TAG; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return ARTICLE_RESET_STATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CHECK_AUTH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return COMMENT_CREATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return COMMENT_DESTROY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return FAVORITE_ADD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return FAVORITE_REMOVE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return FETCH_ARTICLE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return FETCH_ARTICLES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return FETCH_COMMENTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return FETCH_PROFILE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return FETCH_PROFILE_FOLLOW; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return FETCH_PROFILE_UNFOLLOW; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return FETCH_TAGS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return LOGIN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return LOGOUT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return REGISTER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return UPDATE_USER; });
var ARTICLE_PUBLISH = 'publishArticle';
var ARTICLE_DELETE = 'deleteArticle';
var ARTICLE_EDIT = 'editArticle';
var ARTICLE_EDIT_ADD_TAG = 'addTagToArticle';
var ARTICLE_EDIT_REMOVE_TAG = 'removeTagFromArticle';
var ARTICLE_RESET_STATE = 'resetArticleState';
var CHECK_AUTH = 'checkAuth';
var COMMENT_CREATE = 'createComment';
var COMMENT_DESTROY = 'destroyComment';
var FAVORITE_ADD = 'addFavorite';
var FAVORITE_REMOVE = 'removeFavorite';
var FETCH_ARTICLE = 'fetchArticle';
var FETCH_ARTICLES = 'fetchArticles';
var FETCH_COMMENTS = 'fetchComments';
var FETCH_PROFILE = 'fetchProfile';
var FETCH_PROFILE_FOLLOW = 'fetchProfileFollow';
var FETCH_PROFILE_UNFOLLOW = 'fetchProfileUnfollow';
var FETCH_TAGS = 'fetchTags';
var LOGIN = 'login';
var LOGOUT = 'logout';
var REGISTER = 'register';
var UPDATE_USER = 'updateUser';

/***/ }),

/***/ "tkzz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nav',{staticClass:"navbar navbar-light"},[_c('div',{staticClass:"container"},[_c('router-link',{staticClass:"navbar-brand",attrs:{"to":{ name: 'home' }}},[_vm._v("\n      conduit\n    ")]),_vm._v(" "),(!_vm.isAuthenticated)?_c('ul',{staticClass:"nav navbar-nav pull-xs-right"},[_c('li',{staticClass:"nav-item"},[_c('router-link',{staticClass:"nav-link",attrs:{"active-class":"active","exact":"","to":{ name: 'home' }}},[_vm._v("\n          Home\n        ")])],1),_vm._v(" "),_c('li',{staticClass:"nav-item"},[_c('router-link',{staticClass:"nav-link",attrs:{"active-class":"active","exact":"","to":{ name: 'login' }}},[_c('i',{staticClass:"ion-compose"}),_vm._v("Sign in\n        ")])],1),_vm._v(" "),_c('li',{staticClass:"nav-item"},[_c('router-link',{staticClass:"nav-link",attrs:{"active-class":"active","exact":"","to":{ name: 'register' }}},[_c('i',{staticClass:"ion-compose"}),_vm._v("Sign up\n        ")])],1)]):_c('ul',{staticClass:"nav navbar-nav pull-xs-right"},[_c('li',{staticClass:"nav-item"},[_c('router-link',{staticClass:"nav-link",attrs:{"active-class":"active","exact":"","to":{ name: 'home' }}},[_vm._v("\n          Home\n        ")])],1),_vm._v(" "),_c('li',{staticClass:"nav-item"},[_c('router-link',{staticClass:"nav-link",attrs:{"active-class":"active","to":{ name: 'article-edit' }}},[_c('i',{staticClass:"ion-compose"}),_vm._v(" New Article\n        ")])],1),_vm._v(" "),_c('li',{staticClass:"nav-item"},[_c('router-link',{staticClass:"nav-link",attrs:{"active-class":"active","exact":"","to":{ name: 'settings' }}},[_c('i',{staticClass:"ion-gear-a"}),_vm._v(" Settings\n        ")])],1),_vm._v(" "),(_vm.currentUser.username)?_c('li',{staticClass:"nav-item"},[_c('router-link',{staticClass:"nav-link",attrs:{"active-class":"active","exact":"","to":{ name: 'profile', params: { username: _vm.currentUser.username } }}},[_vm._v("\n          "+_vm._s(_vm.currentUser.username)+"\n        ")])],1):_vm._e()])],1)])}
var staticRenderFns = []


/***/ }),

/***/ "wYMm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return API_URL; });
/* unused harmony default export */ var _unused_webpack_default_export = ({});
var API_URL = 'https://test.api.blog.funktechno.com/api';

/***/ }),

/***/ "xJD8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_TheHeader__ = __webpack_require__("BVEk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_TheFooter__ = __webpack_require__("GyQG");
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'App',
  components: {
    RwvHeader: __WEBPACK_IMPORTED_MODULE_0__components_TheHeader__["a" /* default */],
    RwvFooter: __WEBPACK_IMPORTED_MODULE_1__components_TheFooter__["a" /* default */]
  }
});

/***/ })

},[0]);


// WEBPACK FOOTER //
// static/js/app.53ffd9006dafd221e9c2.js